import type { FunctionComponent } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import { Skeleton } from '~/ui/core/skeleton/Skeleton';
import { Spinner } from '~/ui/core/spinner/Spinner';

export const CompanyInformationLoadingSkeletons: FunctionComponent = () => {
    const translate = useTranslate();

    return (
        <div className="flex flex-col gap-4xl">
            <div className="flex items-center gap-m">
                <Spinner />
                <span className="text-sm text-black-500">
                    {translate('pages.job-architecture-v2.setup-dialog.company-information.looking-up')}
                </span>
            </div>
            <div aria-hidden={true} className="flex flex-col gap-4xl">
                <div className="flex flex-col gap-m">
                    <Skeleton height="14px" width="120px" />
                    <Skeleton height="60px" width="100%" />
                </div>
                <div className="flex flex-col gap-m">
                    <Skeleton height="14px" width="100px" />
                    <Skeleton height="60px" width="100%" />
                </div>
                <div className="flex flex-col gap-m">
                    <Skeleton height="14px" width="110px" />
                    <Skeleton height="36px" width="200px" />
                </div>
            </div>
        </div>
    );
};
